module.exports = __webpack_public_path__ + "static/img/core1@2x.43dbdf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/core1@2x.png
// module id = bJH7
// module chunks = 1